function safeDecode (val) {
  try { return decodeURIComponent(val) } catch (e) { return val }
}

function safeEncode (val) {
  try { return encodeURIComponent(val) } catch (e) { return String(val) }
}

function isBrowser () {
  return typeof document !== 'undefined' && typeof document.cookie === 'string'
}

export const cookie = {
  /**
   * 读取 cookie
   * @param {string} name
   * @returns {string}
   */
  get (name) {
    if (!isBrowser()) return ''
    const key = name + '='
    const parts = document.cookie ? document.cookie.split('; ') : []
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i]
      if (part.indexOf(key) === 0) {
        return safeDecode(part.substring(key.length))
      }
    }
    return ''
  },

  /**
   * 设置 cookie
   * @param {string} name
   * @param {string|number|boolean} value
   * @param {object} [options]
   * @param {number} [options.days] 过期天数（与 expires 二选一）
   * @param {Date} [options.expires] 过期时间
   * @param {string} [options.path] 默认 '/'
   * @param {string} [options.domain]
   * @param {boolean} [options.secure]
   * @param {'Lax'|'Strict'|'None'} [options.sameSite] 默认 'Lax'
   */
  set (name, value, options = {}) {
    if (!isBrowser()) return
    const path = options.path || '/'
    const sameSite = options.sameSite || 'Lax'
    let expires = options.expires
    if (!expires && typeof options.days === 'number') {
      const d = new Date()
      d.setTime(d.getTime() + options.days * 24 * 60 * 60 * 1000)
      expires = d
    }
    let str = name + '=' + safeEncode(value)
    if (expires instanceof Date) str += '; Expires=' + expires.toUTCString()
    if (path) str += '; Path=' + path
    if (options.domain) str += '; Domain=' + options.domain
    if (options.secure) str += '; Secure'
    if (sameSite) str += '; SameSite=' + sameSite
    document.cookie = str
  },

  /**
   * 删除 cookie
   * @param {string} name
   * @param {object} [options] 需与 set 时的 path/domain 保持一致
   */
  remove (name, options = {}) {
    cookie.set(name, '', { ...options, expires: new Date(0) })
  }
}




// WEBPACK FOOTER //
// ./src/utils/cookie.js